// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountFeature } from '@shared/utils/Account/AccountFeature';
import { BaseCustomTableFormatter } from './BaseCustomTableFormatter';
import { CopyTradingFormatter } from './CopyTradingFormatter';
export var BaseCustomTableFormatterName;
(function (BaseCustomTableFormatterName) {
    BaseCustomTableFormatterName["Balance"] = "balanceFormatter";
    BaseCustomTableFormatterName["ProjectedBalance"] = "projectedBalanceFormatter";
    BaseCustomTableFormatterName["AvailableFunds"] = "availableFundsFormatter";
    BaseCustomTableFormatterName["BlockedBalance"] = "blockedBalanceFormatter";
    BaseCustomTableFormatterName["UnsettledCash"] = "unsettledCashFormatter";
    BaseCustomTableFormatterName["MarginUsed"] = "initialMarginReqFormatter";
    BaseCustomTableFormatterName["MarginUsedPercent"] = "initialMarginReqPercentFormatter";
    BaseCustomTableFormatterName["TotalMaintReq"] = "maintMarginReqFormatter";
    BaseCustomTableFormatterName["RiskLevelPercent"] = "maintMarginReqPercentFormatter";
    BaseCustomTableFormatterName["MarginWarningLevel"] = "marginWarningLevelFormatter";
    BaseCustomTableFormatterName["MarginAvailable"] = "marginAvailableFormatter";
    BaseCustomTableFormatterName["WarningMargin"] = "warningMarginFormatter";
    BaseCustomTableFormatterName["BlockedForStocks"] = "blockedForStocksFormatter";
    BaseCustomTableFormatterName["StocksOrdersReq"] = "stocksOrdersReqFormatter";
    BaseCustomTableFormatterName["OpenGrossPL"] = "openGrossPLFormatter";
    BaseCustomTableFormatterName["OpenNetPL"] = "openNetPLFormatter";
    BaseCustomTableFormatterName["OpenPostionsNumber"] = "openPositionsCountFormatter";
    BaseCustomTableFormatterName["OpenOrdersNumber"] = "openOrdersCountFormatter";
    BaseCustomTableFormatterName["TodayGrossPNL"] = "todaysGrossFormatter";
    BaseCustomTableFormatterName["TodaysNetProfit"] = "todaysNetFormatter";
    BaseCustomTableFormatterName["TodaysFee"] = "todaysFeesFormatter";
    BaseCustomTableFormatterName["TodayVolume"] = "todaysVolumeFormatter";
    BaseCustomTableFormatterName["TodayTrades"] = "todaysTradesFormatter";
    BaseCustomTableFormatterName["CopyTrading"] = "copyTradingFormatter";
})(BaseCustomTableFormatterName || (BaseCustomTableFormatterName = {}));
// Map associating formatter names with their special constructors (only for specific formatters)
const CustomFormatterMap = {
    [BaseCustomTableFormatterName.CopyTrading]: CopyTradingFormatter
};
export function GetCustomFormatters() {
    const formatters = [];
    for (const formatterName in BaseCustomTableFormatterName) {
        if (AccountFeature[formatterName] != null) {
            const name = BaseCustomTableFormatterName[formatterName];
            const FormatterConstructor = CustomFormatterMap[name] || BaseCustomTableFormatter; // Use a specific formatter from FormatterMap or fall back to BaseCustomTableFormatter
            const formatter = new FormatterConstructor(name, AccountFeature[formatterName]); // Create an instance of the appropriate formatter
            formatters.push(formatter);
        }
    }
    return formatters;
}
export const FAILED_TO_FORMAT = 'Too many values to format or inputValue == null';
